import React from 'react';
import { useTranslatedContent } from '../../../i18n/hooks/useTranslatedContent';
import { Database, Settings, Users, BarChart as ChartBar } from 'lucide-react';
import Button from '../../common/Button';

const ERPSolution = () => {
  const { t } = useTranslatedContent('erp');

  return (
    <div className="bg-gradient-to-br from-violet-900 to-purple-900 rounded-3xl p-8 lg:p-12 text-white">
      <div className="text-center mb-12">
        <h3 className="text-2xl font-semibold">{t('solutions.odoo.title')}</h3>
        <p className="mt-4 text-violet-100">{t('solutions.odoo.description')}</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Database className="h-8 w-8 text-violet-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{t('solutions.odoo.features.platform.title')}</h4>
          <p className="text-violet-100">{t('solutions.odoo.features.platform.description')}</p>
          <ul className="mt-4 space-y-2">
            <li className="flex items-center text-violet-100">
              <Settings className="h-5 w-5 text-violet-400 mr-2" />
              Modular architecture
            </li>
            <li className="flex items-center text-violet-100">
              <Users className="h-5 w-5 text-violet-400 mr-2" />
              Multi-company support
            </li>
            <li className="flex items-center text-violet-100">
              <ChartBar className="h-5 w-5 text-violet-400 mr-2" />
              Real-time analytics
            </li>
          </ul>
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
          <Settings className="h-8 w-8 text-violet-400 mb-4" />
          <h4 className="text-lg font-semibold mb-2">{t('solutions.odoo.features.automation.title')}</h4>
          <p className="text-violet-100">{t('solutions.odoo.features.automation.description')}</p>
          <ul className="mt-4 space-y-2">
            <li className="flex items-center text-violet-100">
              <Database className="h-5 w-5 text-violet-400 mr-2" />
              Process automation
            </li>
            <li className="flex items-center text-violet-100">
              <Settings className="h-5 w-5 text-violet-400 mr-2" />
              Custom workflows
            </li>
            <li className="flex items-center text-violet-100">
              <ChartBar className="h-5 w-5 text-violet-400 mr-2" />
              Business intelligence
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center">
        <Button
          variant="secondary"
          className="bg-white text-violet-900 hover:bg-violet-50"
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          {t('cta')}
        </Button>
      </div>
    </div>
  );
};

export default ERPSolution;